import { type Dispatch, type SetStateAction, useState } from "react";
import {
  type SortType,
  useCatalogStore,
} from "@/features/catalog/stores/catalogStore";

interface BoardListControls {
  currentSort: SortType;
  searchQuery: string;
  selectedTag: string | null;
  hiddenTags: string[];
}

export function useBoardListPage(
  currentSort: SortType,
): [number, Dispatch<SetStateAction<number>>] {
  const searchQuery = useCatalogStore((state) => state.searchQuery);
  const selectedTag = useCatalogStore((state) => state.selectedTag);
  const hiddenTags = useCatalogStore((state) => state.hiddenTags);
  const [page, setPage] = useState(1);
  const [previousControls, setPreviousControls] = useState<BoardListControls>({
    currentSort,
    searchQuery,
    selectedTag,
    hiddenTags,
  });

  if (
    currentSort !== previousControls.currentSort ||
    searchQuery !== previousControls.searchQuery ||
    selectedTag !== previousControls.selectedTag ||
    hiddenTags !== previousControls.hiddenTags
  ) {
    setPreviousControls({
      currentSort,
      searchQuery,
      selectedTag,
      hiddenTags,
    });
    if (page !== 1) setPage(1);
  }

  return [page, setPage];
}
